import React, { useEffect, useState } from 'react'
import intl from 'react-intl-universal'
import { useOrdersContext } from '../../context'
import { OrdersCancelModal } from './modal'
import ButtonIcon from 'components/button-icon'
import { IconTrash } from 'components/icons/icn-index.icon'

const OrdersCancel = () => {
  const {
    items,
    checkbox
  } = useOrdersContext()

  const [openModal, setOpenModal] = useState(false)
  const [cancelableItems, setCancelableItems] = useState([])

  useEffect(() => {
    const cancelableItems = items.filter(item => checkbox.includes(item.Id))
    setCancelableItems(cancelableItems)
  }, [checkbox])

  return (
    <React.Fragment>
      <div
        className="btn-content"
        title={intl.get("requestOrders.cancelOrdersInBulk")}
      >
        <ButtonIcon
          buttonIcon={<IconTrash color={"var(--color-action-default)"} />}
          buttonType="default"
          buttonText={intl.get("commons.cancel")}
          onClick={() => setOpenModal(true)}
          disabled={cancelableItems.length === 0}
          style={{ width: '160px' }}
          data-testid="button-cancel-orders"
        />
      </div>
      {openModal && <OrdersCancelModal
        open={openModal}
        close={() => setOpenModal(!openModal)}
        data={cancelableItems}
      />}
    </React.Fragment>
  )
}

export default OrdersCancel
